import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class LabeledIcon extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.node.isRequired,
    prefixIcon: PropTypes.string,
    suffixIcon: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };

  render() {
    const { label, prefixIcon, suffixIcon, className, id } = this.props;

    return (
      <span className={className} id={id}>
        {prefixIcon && (
          <span>
            <i className={`fa-${prefixIcon}`} />{' '}
          </span>
        )}
        {label}
        {suffixIcon && (
          <span>
            {' '}
            <i className={`fa-${suffixIcon}`} />
          </span>
        )}
      </span>
    );
  }
}
